import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContent,[_c(VRow,[_c(VCol),_c(VCol,[(_vm.noError)?_c('PasswordResetForm',{attrs:{"setNewPassword":_vm.setNewPassword,"busy":_vm.busy},on:{"passwordChanged":function($event){return _vm.passwordChanged($event)}}}):_c('div',[_vm._v("\n        Something went wrong...\n      ")])],1),_c(VCol)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }